import { Button } from "@mui/material";
import { closeNotification } from "../reducers/ownApp";
import { useDispatch } from "react-redux";

export const DismissSnackbar = ({ notificationKey }) => {
  const dispatch = useDispatch();

  return (
    <Button onClick={() => dispatch(closeNotification(notificationKey))}>
      Close
    </Button>
  );
};
